import { API_URL } from "./constant";

export const apiGet = async <T>(url: string): Promise<T> => {
  try {
    const response = await fetch(API_URL + url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to fetch data");
    }

    return await response.json();
  } catch (error) {
    console.error("GET request error:", error);
    throw error;
  }
};

export const apiPost = async <T, U>(url: string, body: T): Promise<U> => {
  try {
    const response = await fetch(API_URL + url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to post data");
    }

    return await response.json();
  } catch (error) {
    console.error("POST request error:", error);
    throw error;
  }
};
